var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _path1, _g5, _path10, _path11, _g6, _path12, _g7, _path13, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_723)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 41,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5227 7.48888C8.04943 7.48888 6.02612 9.51252 6.02612 11.9856V51.2946C6.02612 53.7679 8.04943 55.7915 10.5227 55.7915H42.2741C44.7474 55.7915 46.7708 53.7679 46.7708 51.2946V18.6162C46.7708 17.6413 46.3584 16.7118 45.6354 16.058L37.1466 8.38023C36.5126 7.80649 35.6876 7.48888 34.8326 7.48888H10.5227Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_723)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8325 7.48955H10.5225C8.04958 7.48955 6.02612 9.513 6.02612 11.9863V51.2953C6.02612 53.7685 8.04958 55.792 10.5225 55.792H42.2741C44.7474 55.792 46.7708 53.7685 46.7708 51.2953V18.6169C46.7708 17.642 46.3583 16.7125 45.6352 16.0585L37.1466 8.38073C36.5124 7.80715 35.6876 7.48955 34.8325 7.48955Z",
    fill: "#E7E7E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 15,
    width: 11,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9351 15.4687H46.7704V24.0427H36.9351V15.4687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9353 17.2951L46.7708 24.0398V15.4671L36.9353 17.2951Z",
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4346 6.8306L48.3317 18.4954H40.035C37.4942 18.4954 35.4346 16.4358 35.4346 13.8951V13.6488V6.8306Z",
    fill: "#D2D3D4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 8,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53735 8.98945H14.4179V14.2473H7.53735V8.98945Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.610001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33825 14.226C7.79085 14.1085 7.44201 13.5699 7.5597 13.022C8.14965 10.2726 10.8664 8.51563 13.6161 9.10558C14.1635 9.2231 14.5121 9.76172 14.3946 10.3096C14.2771 10.8575 13.738 11.2055 13.1906 11.0882C11.5343 10.7328 9.89755 11.7911 9.54213 13.4475C9.42478 13.9954 8.88565 14.3434 8.33825 14.226Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -5,
    width: 38,
    height: 38
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.98755 -4.7029H31.6196V32.9043H-5.98755V-4.7029Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.649994
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6193 14.101C31.6193 24.4857 23.2009 32.9041 12.8162 32.9041C2.43146 32.9041 -5.98706 24.4857 -5.98706 14.101C-5.98706 3.71622 2.43146 -4.7023 12.8162 -4.7023C23.2009 -4.7023 31.6193 3.71622 31.6193 14.101Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -505,
    y: -390,
    width: 607,
    height: 782
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-504.847 -389.85H101.321V391.75H-504.847V-389.85Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11_723)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 24,
    width: 31,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4849 24.0458H41.0111V44.3445H11.4849V24.0458Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.270004
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4445 27.3425H13.0514C12.1895 27.3425 11.4844 26.6374 11.4844 25.7756V25.6139C11.4844 24.7519 12.1895 24.0468 13.0514 24.0468H39.4445C40.3063 24.0468 41.0112 24.7519 41.0112 25.6139V25.7756C41.0112 26.6374 40.3063 27.3425 39.4445 27.3425Z",
    fill: "#323139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4445 35.8413H13.0514C12.1895 35.8413 11.4844 35.1362 11.4844 34.2746V34.1127C11.4844 33.2509 12.1895 32.5458 13.0514 32.5458H39.4445C40.3063 32.5458 41.0112 33.2509 41.0112 34.1127V34.2746C41.0112 35.1362 40.3063 35.8413 39.4445 35.8413Z",
    fill: "#323139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4445 44.3462H13.0514C12.1895 44.3462 11.4844 43.6411 11.4844 42.7795V42.6175C11.4844 41.7557 12.1895 41.0506 13.0514 41.0506H39.4445C40.3063 41.0506 41.0112 41.7557 41.0112 42.6175V42.7795C41.0112 43.6411 40.3063 44.3462 39.4445 44.3462Z",
    fill: "#323139"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 41,
    height: 50
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.506 3.73998C17.0329 3.73998 15.0093 5.76341 15.0093 8.23668V47.5457C15.0093 50.0188 17.0329 52.0422 19.506 52.0422H51.2576C53.7307 52.0422 55.7541 50.0188 55.7541 47.5457V14.8673C55.7541 13.8922 55.3416 12.9629 54.6186 12.3088L46.1297 4.63113C45.4959 4.05756 44.671 3.73998 43.8157 3.73998H19.506Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11_723)"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8159 3.7415H19.5061C17.033 3.7415 15.0095 5.76496 15.0095 8.23822V47.5472C15.0095 50.0205 17.033 52.0439 19.5061 52.0439H51.2575C53.7308 52.0439 55.7542 50.0205 55.7542 47.5472V14.8688C55.7542 13.8939 55.3417 12.9644 54.6186 12.3105L46.13 4.63268C45.4958 4.0591 44.671 3.7415 43.8159 3.7415Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 11,
    width: 11,
    height: 10
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9194 11.7204H55.7547V20.2927H45.9194V11.7204Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 13.5483L55.7543 20.2932V11.7204L45.9189 13.5483Z",
    fill: "black"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.418 3.08279L57.3151 14.7476H49.0184C46.4776 14.7476 44.418 12.688 44.418 10.1473V9.90099V3.08279Z",
    fill: "#E7E7E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 8,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.52 5.2409H23.4005V10.4971H16.52V5.2409Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.610001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3214 10.4697C16.774 10.3522 16.4252 9.81354 16.5429 9.26563C17.1328 6.5163 19.8495 4.75928 22.5994 5.34923C23.1466 5.46675 23.4953 6.00537 23.3778 6.55328C23.2602 7.10118 22.7211 7.44918 22.1737 7.33183C20.5175 6.97641 18.8807 8.03474 18.5255 9.69112C18.4079 10.239 17.8688 10.587 17.3214 10.4697Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: -9,
    width: 39,
    height: 39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99634 -8.44557H40.6018V29.1616H2.99634V-8.44557Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.639999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6025 10.3585C40.6025 20.7433 32.1841 29.1616 21.7994 29.1616C11.4146 29.1616 2.99609 20.7433 2.99609 10.3585C2.99609 -0.0262146 11.4146 -8.44474 21.7994 -8.44474C32.1841 -8.44474 40.6025 -0.0262146 40.6025 10.3585Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 30,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4673 20.2863H49.9952V40.5867H20.4673V20.2863Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.520004
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4282 23.5813H22.0352C21.1734 23.5813 20.4683 22.8762 20.4683 22.0144V21.8526C20.4683 20.9907 21.1734 20.2858 22.0352 20.2858H48.4282C49.29 20.2858 49.995 20.9907 49.995 21.8526V22.0144C49.995 22.8762 49.29 23.5813 48.4282 23.5813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4282 32.084H22.0352C21.1734 32.084 20.4683 31.379 20.4683 30.5173V30.3555C20.4683 29.4935 21.1734 28.7884 22.0352 28.7884H48.4282C49.29 28.7884 49.995 29.4935 49.995 30.3555V30.5173C49.995 31.379 49.29 32.084 48.4282 32.084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.428 40.585H22.0349C21.1731 40.585 20.468 39.8799 20.468 39.0182V38.8563C20.468 37.9945 21.1731 37.2894 22.0349 37.2894H48.428C49.2898 37.2894 49.9947 37.9945 49.9947 38.8563V39.0182C49.9947 39.8799 49.2898 40.585 48.428 40.585Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8707dde5c3265579a0f754263f20aec2.svg";
export { ForwardRef as ReactComponent };